import * as React from 'react'
import { Slot } from '@radix-ui/react-slot'
import { tw } from 'utils/classnames'

type TextTag = 'h1' | 'h2' | 'h3' | 'h4' | 'p'

export interface TextProps extends React.HTMLAttributes<HTMLElement> {
  variant?: TextTag
  asChild?: boolean
  text?: string
  className?: string
  children?: React.ReactNode
}

const baseStyles: Record<TextTag, string> = {
  h1: 'font-light text-[54px] leading-[64px] max-md:text-[40px] max-md:leading-[48px]',
  h2: 'text-[40px] leading-[52.8px] max-md:text-[32px] max-md:leading-[42px]',
  h3: 'text-20 leading-[28px] font-bold',
  h4: 'text-18 leading-[28px] font-medium',
  p: 'text-20 leading-[28px] max-md:text-[16px] max-md:leading-[24px]',
}

export const Text: React.FC<TextProps> = ({
  variant = 'p',
  asChild,
  text,
  className,
  children,
  ...props
}) => {
  const Component = asChild ? Slot : variant

  return (
    <Component className={tw(baseStyles[variant], className)} {...props}>
      {text || children}
    </Component>
  )
}
